var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.ads
    ? _c(_vm.currentAdComponent, {
        tag: "component",
        attrs: { ads: _vm.ads, "search-query": _vm.searchQuery }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }